import React from "react";
import { ThemeProvider } from "styled-components"
import Layout from "../components/layout"
import SEO from "../components/seo";
import Navigation from "sections/Navigation";
import BannerTwo from "sections/BannerTwo";
import Service from "sections/Service";

import About from "sections/About";

import Wallet from "sections/Wallet";
import Stack from "sections/Stack"; 
import Faq from "sections/Faq";
import Footer from "sections/Footer";

import theme from "assets/theme/theme";
import GlobalStyle from "assets/theme";

const IndexPage = () => (
  <ThemeProvider theme={theme}>
    <GlobalStyle />
    <Layout>
      <SEO  title="Web Scraping, extraemos la información que necesites desde la web"
            meta="Web Scraping, Potencia tu negocio automatizando la extracción de información sobre precios, inventarios, eventos, entre otros. Cotízanos." 
            lang="es" 
            description="Web Scraping, Potencia tu negocio automatizando la extracción de información sobre precios, inventarios, eventos, entre otros. Cotízanos. " />
      <Navigation />
      <BannerTwo />
      <Service />
      <About />
      <Wallet />
      <Faq />
      <Stack /> 
     
    
      <Footer />
    </Layout>
  </ThemeProvider>
)

export default IndexPage
